import { CourseWithChapters } from "@jelly/lesson";
import { formatLessonsForChapter } from "../../../services/Utils";
import lesson01 from "../../lesson/course-03/lesson-01/lesson";
import lesson02 from "../../lesson/course-03/lesson-02/lesson";
import lesson03 from "../../lesson/course-03/lesson-03/lesson";
import lesson04 from "../../lesson/course-03/lesson-04/lesson";
import lesson05 from "../../lesson/course-03/lesson-05/lesson";
import lesson06 from "../../lesson/course-03/lesson-06/lesson";
import lesson07 from "../../lesson/course-03/lesson-07/lesson";
import lesson08 from "../../lesson/course-03/lesson-08/lesson";
import lesson09 from "../../lesson/course-03/lesson-09/lesson";
import lesson10 from "../../lesson/course-03/lesson-10/lesson";
import lesson11 from "../../lesson/course-03/lesson-11/lesson";
import lesson12 from "../../lesson/course-03/lesson-12/lesson";
import lesson13 from "../../lesson/course-03/lesson-13/lesson";
import lesson14 from "../../lesson/course-03/lesson-14/lesson";
import lesson15 from "../../lesson/course-03/lesson-15/lesson";
import lesson16 from "../../lesson/course-03/lesson-16/lesson";
import lesson17 from "../../lesson/course-03/lesson-17/lesson";
import lesson18 from "../../lesson/course-03/lesson-18/lesson";
import lesson19 from "../../lesson/course-03/lesson-19/lesson";
import lesson20 from "../../lesson/course-03/lesson-20/lesson";
import lesson21 from "../../lesson/course-03/lesson-21/lesson";
import lesson22 from "../../lesson/course-03/lesson-22/lesson";
import lesson23 from "../../lesson/course-03/lesson-23/lesson";
import lesson24 from "../../lesson/course-03/lesson-24/lesson";
import lesson25 from "../../lesson/course-03/lesson-25/lesson";
import lesson26 from "../../lesson/course-03/lesson-26/lesson";
import lesson27 from "../../lesson/course-03/lesson-27/lesson";
import lesson28 from "../../lesson/course-03/lesson-28/lesson";
import lesson29 from "../../lesson/course-03/lesson-29/lesson";
import lesson30 from "../../lesson/course-03/lesson-30/lesson";
import case01 from "../../lesson/course-03/case-01/case";
import case02 from "../../lesson/course-03/case-02/case";
import authorMv from "../course-01/authors/author-mv";
import authorLa from "../course-02/authors/author-la";
import authorAh2 from "../course-02/authors/author-ah2";
import authorAh from "../course-02/authors/author-ah";
import authorAke from "../course-02/authors/author-ake";
import authorTw from "./authors/author-tw";
import authorOd from "./authors/author-od";
import authorApg from "./authors/author-apg";

/* eslint-disable max-len */
const data: CourseWithChapters = {
  id: "49817b85-0b30-4661-8a25-1e5176041865",
  publicId: "3",
  slug: "acoustic-simulations-and-auralization",
  name: "Acoustic Simulations And Auralization",
  description:
    "Welcome to the course on acoustical simulation and auralization — a field that enables us to model sound propagation in different environments and makes it possible to acoustically experience simulated scenarios using auralizations. Learn about the required signal processing fundamentals and explore ray-based and wave-based models for predicting sound fields in rooms. Discover the simulation concepts for sound transmission in buildings and outdoor environments and delve into ear-canal-related signal simulation and headphone reproduction using binaural synthesis, but also learn about sophisticated methods to reproduce sound via loudspeakers. Explore how binaural transfer path synthesis is applied in the automotive industry and which models can be used to predict outdoor sound propagation. This course does not only present different concepts and applications for simulation and auralization, but also introduces the limitations, the uncertainties and validity of such approaches.",
  shortDescription:
    "In order to control how sound propagates in an environment, adequate simulation models are required. This course introduces the necessary signal processing fundamentals, the simulation models and the possibility to make the simulated scenarios audible - using auralization.",
  chapters: [
    {
      id: "46b50167-f798-40d1-a85c-ab95fe477079",
      name: "Acoustic Simulations And Auralization",
      position: 0,
      chapterLessons: formatLessonsForChapter([lesson01, lesson02, lesson03, lesson04, lesson05]),
    },
    {
      id: "b4740b88-e812-4854-aeae-bcb49f9b0975",
      name: "Room acoustic simulation",
      position: 1,
      chapterLessons: formatLessonsForChapter([lesson06, lesson07, lesson08, lesson09, lesson10, lesson11], 4),
    },
    {
      id: "e2c7adf9-16c2-4211-8994-3eb467695629",
      name: "Models for noise control and sound design",
      position: 2,
      chapterLessons: formatLessonsForChapter([lesson12, lesson13, lesson14, lesson15], 10),
    },
    {
      id: "a5cac9c4-6d91-4251-a642-bf93659f8569",
      name: "Auralization",
      position: 3,
      chapterLessons: formatLessonsForChapter([lesson16, lesson17, lesson18, lesson19], 14),
    },
    {
      id: "7e4dd276-f78e-40a8-b00d-197bffbe6b10",
      name: "Reproduction",
      position: 4,
      chapterLessons: formatLessonsForChapter([lesson20, lesson21, lesson22, lesson23, lesson24], 18),
    },
    {
      id: "6d6bbb1b-b731-410e-88f4-38c7c6a68c35",
      name: "Application and evaluation of simulations",
      position: 5,
      chapterLessons: formatLessonsForChapter([lesson25, lesson26, lesson27, lesson28, lesson29, lesson30], 23),
    },
    {
      id: "d2fce814-c23d-477a-8520-da7104fd3d24",
      name: "Case studies",
      position: 6,
      chapterLessons: formatLessonsForChapter([case01, case02], 30),
    },
  ],
  authors: [authorMv, authorLa, authorAh2, authorAh, authorAke, authorTw, authorOd, authorApg],
};

/* eslint-enable max-len */

export default data;
